module.exports = __webpack_public_path__ + "school/img/head - 副本.0bffa0d0.png";